import { useCallback } from 'react';
import useStateWithCallback from './useStateWithCallback';

const useStateWithObserver = (initializer, observerCb) => {
  const [state, setState] = useStateWithCallback(initializer);

  const setStateWithObserver = useCallback((setter) => {
    setState(setter, observerCb);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [state, setStateWithObserver];
};

export default useStateWithObserver;
